// extracted by mini-css-extract-plugin
export default {"Title":"LoginCommon_Title__qimRM","LoginInsteadText":"LoginCommon_LoginInsteadText__gT7Ub"};